import React from 'react';

const ConsentIcon = ({ width = 20, height = 24, className }: { width?: number; height?: number; className?: string }) => {
  // tslint:disable max-line-length
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 24"
    >
      <g fillRule="evenodd">
        <path
          d="M18.5,21.9885057 L18.5,2.01149425 C18.5,1.72162494 18.2977479,1.5 18.0769231,1.5 L1.92307692,1.5 C1.70225214,1.5 1.5,1.72162495 1.5,2.01149425 L1.5,21.9885057 C1.5,22.2783751 1.70225213,22.5 1.92307692,22.5 L18.0769231,22.5 C18.2977479,22.5 18.5,22.2783751 18.5,21.9885057 Z M19.5,21.9885057 C19.5,22.8112801 18.8714829,23.5 18.0769231,23.5 L1.92307692,23.5 C1.12851708,23.5 0.5,22.8112801 0.5,21.9885057 L0.5,2.01149425 C0.5,1.18871988 1.12851709,0.5 1.92307692,0.5 L18.0769231,0.5 C18.8714829,0.5 19.5,1.18871988 19.5,2.01149425 L19.5,21.9885057 Z M15.6889648,14.5 L3.99765714,14.5 L3.99765714,15.5 L15.6889648,15.5 L15.6889648,14.5 Z M15.6889648,17 L3.99765714,17 L3.99765714,18 L15.6889648,18 L15.6889648,17 Z M15.6889648,19.5 L3.99765714,19.5 L3.99765714,20.5 L15.6889648,20.5 L15.6889648,19.5 Z M13.6076775,4.69002734 L8.89470886,10.6550813 L6.35706036,8.06632569 C6.16375446,7.8691267 5.84718771,7.86597073 5.64998871,8.05927662 C5.45278972,8.25258252 5.44963375,8.56914927 5.64293964,8.76634827 L8.9754331,12.1659567 L14.3923225,5.30997266 C14.5635157,5.09329893 14.5266464,4.77887067 14.3099727,4.60767749 C14.0932989,4.43648432 13.7788707,4.4733536 13.6076775,4.69002734 Z"
        />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
};

export default ConsentIcon;
